import "./Rating.scss";

import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { getLingoRatingCriterias } from "../../store/middleware";
import Settings from "../../assets/images/icons/icon_settings_header.svg";

function Rating() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { ratingCriterias } = useSelector((state) => state.genericReducer);

  useEffect(() => {
    dispatch(getLingoRatingCriterias(true));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header t={t} title="Rating" icon={<img src={Settings} alt="Settings" />} typeIcon="custom" />

        <div className="content">
          <div className="table">
            <div className="topTable">
              <h3>Student</h3>
              <Link to="/rating-student/new" state={{ data: "Student" }}>
                <button className="buttonRight">
                  <i className="fa fa-plus" aria-hidden="true"></i> Add new Criterion
                </button>
              </Link>
            </div>
            <div className="bigBoxTableRating">
              <table>
                <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Status</th>
                  </tr>

                  {ratingCriterias
                    ?.filter((item) => item.target === "student")
                    ?.map((list) => (
                      <tr key={list.id}>
                        <td>{list.nameEnglish}</td>
                        <td>{list.descriptionEnglish}</td>
                        <td>
                          <span style={{ color: list.active ? "#0ED572" : "#FF5666" }}>
                            {list.active ? "Ativo" : "Inativo"}
                          </span>
                        </td>
                        <td>
                          <Link to={`/rating-student/${list.id}`} state={{ data: list }}>
                            <button>
                              View <i className="fa fa-angle-right" aria-hidden="true"></i>
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="topTable">
              <h3>Teacher</h3>

              <Link to="/rating-student/new" state={{ data: "Teacher" }}>
                <button className="buttonRight">
                  <i className="fa fa-plus" aria-hidden="true"></i> Add new Criterion
                </button>
              </Link>
            </div>

            <div className="bigBoxTableRating">
              <table>
                <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Status</th>
                  </tr>

                  {ratingCriterias
                    ?.filter((item) => item.target === "teacher")
                    ?.map((list) => (
                      <tr key={list.id}>
                        <td>{list.nameEnglish}</td>
                        <td>{list.descriptionEnglish}</td>
                        <td>
                          <span style={{ color: list.active ? "#0ED572" : "#FF5666" }}>
                            {list.active ? "Ativo" : "Inativo"}
                          </span>
                        </td>
                        <td>
                          <Link to={`/rating-student/${list.id}`} state={{ data: list }}>
                            <button>
                              View <i className="fa fa-angle-right" aria-hidden="true"></i>
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Rating;
